import React, { lazy, Suspense, useEffect, useMemo, useState } from 'react';
import { CircularLoader } from 'seagull/components/CircularLoader';
import { PdfViewerTestIds } from "./PdfViewer.utils";
import { jsx as _jsx } from "react/jsx-runtime";
const pdfInnerPromise = import("./inner/PdfViewerInner");
const PdfLazyLoader = /*#__PURE__*/lazy(() => pdfInnerPromise.then(module => ({
  default: module.PdfViewerInner
})));
export const PdfViewer = _ref => {
  let {
    getFileUrl,
    singlePageStyle,
    hideSinglePageLoader,
    style
  } = _ref;
  const [url, setUrl] = useState('');
  useEffect(() => {
    const resolveUrl = async () => {
      const resolvedUrl = await getFileUrl();
      setUrl(resolvedUrl);
    };
    resolveUrl();
  }, [getFileUrl]);
  const loader = useMemo(() => /*#__PURE__*/_jsx("div", {
    "data-testid": PdfViewerTestIds.loader(),
    style: {
      position: 'absolute',
      top: 'calc(50% - 16px)',
      left: 'calc(50% - 16px)'
    },
    children: /*#__PURE__*/_jsx(CircularLoader, {
      size: 32
    })
  }), []);
  if (!url) return loader;
  return /*#__PURE__*/_jsx(Suspense, {
    fallback: loader,
    children: /*#__PURE__*/_jsx(PdfLazyLoader, {
      singlePageStyle: singlePageStyle,
      hideSinglePageLoader: hideSinglePageLoader,
      style: style,
      loader: loader,
      url: url
    })
  });
};